import React, { useState, useEffect } from "react";

import { ErrorTextForCounter, SecondsCounterText, UnitSymbolText } from "./styles";

const formatTime = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return `${minutes.toString().padStart(1, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
};

interface CountdownTimerProps {
  initialTime: number;
  onIntervalComplete: (val: boolean) => void;
  lockoutDuration: number;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({
  initialTime,
  onIntervalComplete,
  lockoutDuration,
}) => {
  const [time, setTime] = useState<number>(initialTime);

  useEffect(() => {
    if (time <= 0) {
      onIntervalComplete(false);

      return;
    }
    const timerId = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timerId);

          return 0;
        }

        return prevTime - 1;
      });
    }, 1000);
    const clearAndNotify = () => {
      clearInterval(timerId);
      onIntervalComplete(true);
    };

    const timeoutId = setTimeout(clearAndNotify, 1000);

    return () => {
      clearInterval(timerId);
      clearTimeout(timeoutId);
    };
  }, [time, lockoutDuration]);
  if (initialTime <= 60)
    return (
      <SecondsCounterText>
        {time}
        <UnitSymbolText>s</UnitSymbolText>
      </SecondsCounterText>
    );

  return <ErrorTextForCounter>{formatTime(time)}</ErrorTextForCounter>;
};

export default CountdownTimer;
